import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { clearLegacySessionToken, ensureBackendSession } from "@/lib/session";

const SessionContext = createContext(null);

export function SessionProvider({ children }) {
  const [status, setStatus] = useState("checking");

  const refreshSession = useCallback(async () => {
    setStatus("checking");
    try {
      const ok = await ensureBackendSession();
      clearLegacySessionToken();
      setStatus(ok ? "authenticated" : "unauthenticated");
      return ok;
    } catch {
      clearLegacySessionToken();
      setStatus("unauthenticated");
      return false;
    }
  }, []);

  useEffect(() => {
    refreshSession();
  }, [refreshSession]);

  const value = useMemo(
    () => ({
      status,
      isAuthenticated: status === "authenticated",
      isChecking: status === "checking",
      refreshSession,
    }),
    [status, refreshSession]
  );

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession() {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSession must be used within SessionProvider");
  }
  return context;
}
